import gtl, { GtlBehaviorType } from "@gaming/gtl";

import { OnboardingPageAction } from "./models";
import { getPageName } from "./pageView";

// The format for url is actually just the path without host nor locale. i.e: '/publish/program-selection'
export const logPageAction = (pageAction: OnboardingPageAction) => {
  try {
    const url = new URL(window.location.href);
    gtl.writePageAction(
      getPageName(url.pathname.substring(6)),
      GtlBehaviorType.UserAction,
      pageAction
    );
  } catch (error) {}
};
